import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { apiPostAuth } from "../../utils/api";

export default function ReferralPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [referralCode, setReferralCode] = useState("");
  const [copied, setCopied] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);
  const [hasReferral, setHasReferral] = useState(false);

  useEffect(() => {
    const fetchReferral = async () => {
      try {
        const response = await apiPostAuth("account/referral.php");
        if (response.result === 1 && response.referral_code) {
          setReferralCode(response.referral_code);
          setHasReferral(true);
        } else {
          setHasReferral(false);
        }
      } catch (error) {
        setHasReferral(false);
      } finally {
        setLoading(false);
      }
    };

    fetchReferral();
  }, []);

  const handleCopyCode = () => {
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopyLink = () => {
    const inviteLink = `${window.location.origin}/register?ref=${referralCode}`;
    navigator.clipboard.writeText(inviteLink);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 2000);
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="loading-spinner"></div>
        <p>Loading referral information...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <button onClick={() => navigate("/dashboard")} style={backButtonStyle}>
        ← Back to Dashboard
      </button>

      <h1 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#1f2937" }}>
        Referral Program
      </h1>

      {hasReferral ? (
        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Your Referral Code</h2>
          <div style={codeBoxStyle}>
            <span style={codeTextStyle}>{referralCode}</span>
            <button
              onClick={handleCopyCode}
              className="secondary-button"
              style={{ marginLeft: "10px" }}
            >
              {copied ? "Copied!" : "Copy Code"}
            </button>
            <button
              onClick={handleCopyLink}
              className="secondary-button"
              style={{ marginLeft: "10px" }}
            >
              {copiedLink ? "Link Copied!" : "Copy Invite Link"}
            </button>
          </div>
          <p style={{ fontSize: "0.9rem", color: "#6b7280", marginTop: "10px" }}>
            Share this code or invite link with your friends! For every credit purchase your friend makes,
            <strong> you will earn 5% of the purchased credits</strong>.
            Your friend's account remains unchanged — they pay the same price.
          </p>
        </section>
      ) : (
        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Referral Unavailable</h2>
          <p style={{ fontSize: "0.9rem", color: "#6b7280" }}>
            Your referral code is currently not available. Please check back later.
          </p>
        </section>
      )}

      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>How It Works</h2>
        <ul style={{ paddingLeft: "20px", color: "#4b5563" }}>
          <li>Invite your friends by sharing your referral code or invite link.</li>
          <li>You earn <strong>5% of every credit purchase</strong> they make.</li>
          <li>Your friends’ accounts are not affected — no extra charges or discounts.</li>
          <li>The more your friends buy, the more credits you earn automatically.</li>
        </ul>
      </section>
    </div>
  );
}

/* --- Styles --- */
const sectionStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  marginBottom: "20px",
};

const sectionTitleStyle = {
  fontSize: "1.2rem",
  marginBottom: "10px",
  color: "#1f2937",
};

const codeBoxStyle = {
  display: "flex",
  alignItems: "center",
  padding: "10px",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  backgroundColor: "#f9fafb",
  width: "fit-content",
};

const codeTextStyle = {
  fontWeight: "600",
  color: "#2563eb",
  fontSize: "1.1rem",
};

const backButtonStyle = {
  display: "inline-block",
  padding: "8px 16px",
  backgroundColor: "#f2f6fc",
  color: "#2563eb",
  fontWeight: "500",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "20px",
  transition: "all 0.2s ease",
};
